import { useGetSuggestionsMutation } from "services/client";
import { logError } from "utils/sentry";
import { sectionToSuggestionTypes } from "utils/suggestions";

import { IUser } from "../types/auth";
import { IClientDocument } from "../types/client";

type GetSuggestionsType = ReturnType<typeof useGetSuggestionsMutation>[0];

type IntegrationParams = {
    currentStepData: any;
    user: IUser,
    currentDocument: IClientDocument,
    getSuggestions: GetSuggestionsType;
};

export const runApiIntegration = async ({
    currentStepData,
    user,
    currentDocument,
    getSuggestions,
}: IntegrationParams): Promise<any | null> => {
    if (
        !currentStepData?.apiIntegration ||
        !currentStepData.apiIntegration.targetApi ||
        !user?.id ||
        !currentDocument?.id
    ) {
        return null;
    }

    const apiIntegrationsResult: Record<string, any> = {};

    switch (currentStepData.apiIntegration.targetApi) {
    case "fetchSuggestions": {
        const suggestionTypes = sectionToSuggestionTypes[currentStepData.title];
        if (!suggestionTypes) return null;

        try {
            apiIntegrationsResult["suggestionResults"] = await getSuggestions({
                clientId: user.id,
                documentId: currentDocument.id,
                type: suggestionTypes,
            }).unwrap();

            const filtered = apiIntegrationsResult.suggestionResults.filter(
                (s: any) => s.isSuggested
            );

            if (filtered.length > 0) {
                apiIntegrationsResult.suggestionResults = filtered;
                return apiIntegrationsResult;
            } else {
                return null;
            }
        } catch (error) {
            logError(error);
            return null;
        }
    }

    default: {
        console.warn("Unknown apiIntegration type:", currentStepData.apiIntegration);
        return null;
    }
    }
};
